//@ts-nocheck
import request from '../request';

export const createTrip = async (data = {}) => {
  const { outline, ...otherData } = data;

  const endpoint = outline && outline.trim() ? 'trips/aitripbuilder' : 'trips';
  const payload =
    outline && outline.trim()
      ? { ...otherData, itinerarytext: outline }
      : otherData;

  return request.post(endpoint, payload).then((res) => res);
};

export const createTripDay = (data = {}) =>
  request.post('trips/day', data).then((res) => res);

export const createTripContent = (data = {}) =>
  request.post('trips/content', data).then((res) => res);

export const getTrip = (tripId = '') => {
  return request.get(`trips/${tripId}`).then((res) => res);
};

export const getTrips = (params = '') => {
  return request.get(`trips${params || ''}`).then((res) => res);
};

export const addServiceToTripDay = (data = {}) =>
  request.post('trips/lineitem', data).then((res) => res);

export const updateTripDay = (tripDayId = '', data = {}) =>
  request.put(`trips/day/${tripDayId}`, data).then((res) => res);

export const updateTripContent = (tripContentId = '', data = {}) =>
  request.put(`trips/content/${tripContentId}`, data).then((res) => res);

export const updateTripDayService = (lineItemId = '', data = {}) =>
  request.put(`lineitems/${lineItemId}`, data).then((res) => res);

export const updateTripDaysSequence = (data = {}) =>
  request.put(`trips/days/sequence`, data).then((res) => res);

export const updateTripContentItemSequence = (data = {}) =>
  request.put(`trips/content/sequence`, data).then((res) => res);

export const updateLineItemsSequence = (data = {}) =>
  request.put(`lineitems/sequence`, data).then((res) => res);

export const updateTripStatus = (tripId = '', data = {}) =>
  request.put(`trips/${tripId}/status`, data).then((res) => res);

export const updateTripHeader = (tripId = '', data = {}) =>
  request.put(`trips/${tripId}`, data).then((res) => res);

export const savePaymentPlan = (paymentPlanData = {}) =>
  request.post('paymentplan', paymentPlanData).then((res) => res);

export const deleteTripDay = (tripDayId = '', data = {}) =>
  request.delete(`trips/day/${tripDayId}`, data).then((res) => res);

export const deleteTripContent = (tripContentId = '', data = {}) =>
  request.delete(`trips/content/${tripContentId}`, data).then((res) => res);

export const deleteTripDayService = (lineItemId = '', data = {}) =>
  request.delete(`lineitems/${lineItemId}`, data).then((res) => res);

export const addTripImage = (tripId = '', data = {}) =>
  request.put(`trips/${tripId}/image`, data).then((res) => res);

export const addTripDayImage = (tripDayId = '', data = {}) =>
  request.put(`trips/day/${tripDayId}/image`, data).then((res) => res);

export const addTripContentImage = (tripContentId = '', data = {}) =>
  request.put(`trips/content/${tripContentId}/image`, data).then((res) => res);

export const addTripDayItemImage = (lineItemId = '', data = {}) =>
  request.put(`lineitems/${lineItemId}/image`, data).then((res) => res);

export const updateTripVisibility = (tripId = '', data = {}) =>
  request.put(`trips/${tripId}`, data).then((res) => res);

export const cloneTrip = (tripid = '', data = {}) =>
  request.post(`trip/${tripid}/clone`, data).then((res) => res);

export const createTripPricingPlan = (data = {}) =>
  request.post('tripplans', data).then((res) => res);

export const deleteTripPricingPlan = (tripplanid = '', data = {}) =>
  request.delete(`tripplans/${tripplanid}`, data).then((res) => res);

export const updateTripPricingPlan = (tripplanid = '', data = {}) =>
  request.put(`tripplans/${tripplanid}`, data).then((res) => res);

export const updatePricingPlansOrder = (tripid = '', data = {}) =>
  request.put(`trips/${tripid}/tripplans/reorder`, data).then((res) => res);

export const getTripPricingPlan = (tripid = '', data = {}) =>
  request.get(`tripplans/${tripid}`, data).then((res) => res);

export const getTripAddOns = (tripid = '', data = {}) =>
  request.get(`trips/${tripid}/addons`, data).then((res) => res);

export const createTripAddOn = (tripid = '', data = {}) =>
  request.post(`trips/${tripid}/addons`, data).then((res) => res);

export const updateTripAddOn = (tripid = '', tripaddonid = '', data = {}) =>
  request.put(`trips/${tripid}/addons/${tripaddonid}`, data).then((res) => res);

export const deleteTripAddOn = (tripid = '', tripaddonid = '', data = {}) =>
  request
    .delete(`trips/${tripid}/addons/${tripaddonid}`, data)
    .then((res) => res);

export const reorderTripAddOns = (tripid = '', data = {}) =>
  request.put(`trips/${tripid}/addons/reorder`, data).then((res) => res);

export const updateTripFees = (tripid = '', data = {}) =>
  request.put(`trips/${tripid}/fee`, data).then((res) => res);

export const getTripAmenity = (tripid = '') =>
  request.get(`trips/${tripid}/amenity`).then((res) => res);

export const createTripAmenity = (data = {}) =>
  request.post('trips/amenity', data).then((res) => res);

export const updateTripAmenity = (tripamenityid = '', data = {}) =>
  request.put(`trips/amenity/${tripamenityid}`, data).then((res) => res);

export const deleteTripAmenity = (tripamenityid = '') =>
  request.delete(`trips/amenity/${tripamenityid}`).then((res) => res);

export const updateTripAmenitySequence = (
  tripid = '',
  tripamenityid = '',
  data = {}
) =>
  request
    .put(`trips/${tripid}/amenity/${tripamenityid}/sequence`, data)
    .then((res) => res);

export const reorderTripAmenities = (tripid = '', amenitiesData = []) =>
  request
    .put(`trips/${tripid}/amenity/reorder`, { amenities: amenitiesData })
    .then((res) => res);

export const deleteTrip = (tripId = '') => request.delete(`trips/${tripId}`);

export const getTripPassengerFields = (tripid = '') =>
  request
    .get(`trips/${tripid}/passengerfields`, {
      // Passenger-field configuration is mutated in the same session. Ask a
      // browser/proxy cache to revalidate instead of returning a stale list
      // after a successful create, status change, or reorder.
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache'
      }
    })
    .then((res) => res);

export const getTripPassengerCollectionRounds = (tripid = '') =>
  request.get(`trips/${tripid}/passengercollectionrounds`).then((res) => res);

export const createTripPassengerCollectionRound = (tripid = '', data = {}) =>
  request
    .post(`trips/${tripid}/passengercollectionrounds`, data)
    .then((res) => res);

export const updateTripPassengerCollectionRound = (
  tripid = '',
  trippassengercollectionroundid = '',
  data = {}
) =>
  request
    .put(
      `trips/${tripid}/passengercollectionrounds/${trippassengercollectionroundid}`,
      data
    )
    .then((res) => res);

export const deleteTripPassengerCollectionRound = (
  tripid = '',
  trippassengercollectionroundid = ''
) =>
  request
    .delete(
      `trips/${tripid}/passengercollectionrounds/${trippassengercollectionroundid}`
    )
    .then((res) => res);

export const updateTripPassengerCollectionRoundSequence = (
  tripid = '',
  trippassengercollectionroundid = '',
  data = {}
) =>
  request
    .put(
      `trips/${tripid}/passengercollectionrounds/${trippassengercollectionroundid}/sequence`,
      data
    )
    .then((res) => res);

export const addTripPassengerFieldToCollectionRound = (
  tripid = '',
  trippassengercollectionroundid = '',
  data = {}
) =>
  request
    .post(
      `trips/${tripid}/passengercollectionrounds/${trippassengercollectionroundid}/fields`,
      data
    )
    .then((res) => res);

export const updateTripPassengerCollectionRoundFieldSequence = (
  tripid = '',
  trippassengercollectionroundid = '',
  trippassengerfieldid = '',
  data = {}
) =>
  request
    .put(
      `trips/${tripid}/passengercollectionrounds/${trippassengercollectionroundid}/fields/${trippassengerfieldid}/sequence`,
      data
    )
    .then((res) => res);

export const updateTripPassengerCollectionRoundFieldAssignmentType = (
  tripid = '',
  trippassengercollectionroundid = '',
  trippassengerfieldid = '',
  data = {}
) =>
  request
    .put(
      `trips/${tripid}/passengercollectionrounds/${trippassengercollectionroundid}/fields/${trippassengerfieldid}/assignmenttype`,
      data
    )
    .then((res) => res);

export const deleteTripPassengerCollectionRoundField = (
  tripid = '',
  trippassengercollectionroundid = '',
  trippassengerfieldid = ''
) =>
  request
    .delete(
      `trips/${tripid}/passengercollectionrounds/${trippassengercollectionroundid}/fields/${trippassengerfieldid}`
    )
    .then((res) => res);

export const createTripPassengerField = (tripid = '', data = {}) =>
  request.post(`trips/${tripid}/passengerfields`, data).then((res) => res);

export const resetTripPassengerFieldsToGlobal = (tripid = '') =>
  request
    .post(`trips/${tripid}/passengerfields/reset-from-global`)
    .then((res) => res);

export const updateTripPassengerField = (
  tripid = '',
  trippassengerfieldid = '',
  data = {}
) =>
  request
    .put(`trips/${tripid}/passengerfields/${trippassengerfieldid}`, data)
    .then((res) => res);

export const deleteTripPassengerField = (
  tripid = '',
  trippassengerfieldid = ''
) =>
  request
    .delete(`trips/${tripid}/passengerfields/${trippassengerfieldid}`)
    .then((res) => res);

export const updateTripPassengerFieldSequence = (
  tripid = '',
  trippassengerfieldid = '',
  data = {}
) =>
  request
    .put(
      `trips/${tripid}/passengerfields/${trippassengerfieldid}/sequence`,
      data
    )
    .then((res) => res);

export const updateTripPassengerFieldStatus = (
  tripid = '',
  trippassengerfieldid = '',
  data = {}
) =>
  request
    .put(`trips/${tripid}/passengerfields/${trippassengerfieldid}/status`, data)
    .then((res) => res);

export const getTripDetailedDays = (tripid = '') =>
  request.get(`trips/${tripid}/tripdetaileddays`).then((res) => res);

export const updateTripDetailedDay = (
  tripid = '',
  tripDetailedDayId = '',
  data = {}
) =>
  request
    .put(`trips/${tripid}/tripdetaileddays/${tripDetailedDayId}`, data)
    .then((res) => res);

export const getTravelDoc = (tripid = '') =>
  request.get(`trips/${tripid}/travel-doc`).then((res) => res);
